// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"ComingSoon_pageHolder__1SBuz","english":"ComingSoon_english__jPnXk","persian":"ComingSoon_persian__2B_NS"};